export const sizes = {
    sm: 480,
    md: 768,
    lg: 1024,
    xl: 1200,
    xxl: 1400,

}